<div class="page-section" id="page-series-listing">
    <div class="page-section-header">
        <h1>
            {{
                seriesPageType == 'customType'
                    ? "Organization's Own Content"
                    : 'Series'
            }}
        </h1>
    </div>
    <div class="page-section-content">
        <my-tabs
            [storageKey]="'admin-course-listing-active-tab'"
            (tabChange)="onMainTabChange($event)">
            <my-tab [tabTitle]="'Video Series'">
                <div class="page-section">
                    <div class="page-section-header">
                        <div class="page-section-buttons">
                            <a
                                (click)="doCreate('video')"
                                (keypress)="doCreate('video')"
                                class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon">
                                <svg-icon icon="plus" alt="plus"></svg-icon>
                                <span translate>Create New Video Series</span>
                            </a>
                        </div>
                    </div>
                    <div class="page-section-content">
                        <page-loader *ngIf="!isLoaded"></page-loader>
                        <div class="table-responsive" *ngIf="isLoaded">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th translate>Name</th>
                                        <th style="width: 60px"></th>
                                        <th style="width: 40px"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let course of courses">
                                        <td>
                                            {{ course.label }}
                                            <span *ngIf="course.active === 0"
                                                >(Unpublished)</span
                                            >
                                        </td>
                                        <td>
                                            <a
                                                tabindex="0"
                                                class="pull-right"
                                                (click)="
                                                    goToVideoSeries(course)
                                                "
                                                translate
                                                >View</a
                                            >
                                        </td>
                                        <td>
                                            <a
                                                tabindex="0"
                                                class="action-icon pull-right"
                                                (click)="
                                                    onEdit(course.id, 'video')
                                                "
                                                (keypress)="
                                                    onEdit(course.id, 'video')
                                                "
                                                aria-label="Edit series"
                                                ><svg-icon
                                                    icon="edit"
                                                    class="table-icon"></svg-icon
                                            ></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </my-tab>

            <my-tab [tabTitle]="'Voice Series'">
                <div class="voice-subtab">
                    <my-tabs
                        [storageKey]="'admin-course-listing-voice-subtab'"
                        (tabChange)="onSubTabChange($event)">
                        <my-tab [tabTitle]="'Stories'">
                            <div class="page-section">
                                <div class="page-section-header">
                                    <div class="page-section-buttons">
                                        <a
                                            (click)="doCreate('stories')"
                                            (keypress)="doCreate('stories')"
                                            class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon">
                                            <svg-icon
                                                icon="plus"
                                                alt="plus"></svg-icon>
                                            <span translate
                                                >Create New Stories</span
                                            >
                                        </a>
                                    </div>
                                </div>
                                <div class="page-section-content">
                                    <page-loader
                                        *ngIf="!isLoaded"></page-loader>
                                    <div
                                        class="table-responsive"
                                        *ngIf="isLoaded">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th
                                                        style="width: 30%"
                                                        translate>
                                                        Title
                                                    </th>
                                                    <th style="width: 15%">
                                                        Author
                                                    </th>
                                                    <th
                                                        *ngIf="
                                                            seriesPageType !=
                                                            'customType'
                                                        "
                                                        style="width: 15%">
                                                        Category
                                                    </th>
                                                    <th style="width: 5%"></th>
                                                    <th style="width: 5%"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngIf="
                                                        storyList.length === 0
                                                    ">
                                                    <td
                                                        colspan="5"
                                                        class="no-data-message">
                                                        No data found
                                                    </td>
                                                </tr>
                                                <tr
                                                    *ngFor="
                                                        let course of storyList
                                                    ">
                                                    <td>
                                                        {{ course.titleen }}
                                                    </td>
                                                    <td>
                                                        {{ course.authoren }}
                                                    </td>
                                                    <td
                                                        *ngIf="
                                                            seriesPageType !=
                                                            'customType'
                                                        ">
                                                        {{ course.category }}
                                                    </td>
                                                    <td>
                                                        <a
                                                            tabindex="0"
                                                            class="pull-right"
                                                            (click)="
                                                                voiceRoute(
                                                                    'stories',
                                                                    course.id
                                                                )
                                                            "
                                                            translate
                                                            >View</a
                                                        >
                                                    </td>
                                                    <td>
                                                        <a
                                                            tabindex="0"
                                                            class="action-icon pull-right"
                                                            (click)="
                                                                onEdit(
                                                                    course.id,
                                                                    'stories'
                                                                )
                                                            "
                                                            (keypress)="
                                                                onEdit(
                                                                    course.id,
                                                                    'stories'
                                                                )
                                                            "
                                                            aria-label="Edit story"
                                                            ><svg-icon
                                                                icon="edit"
                                                                class="table-icon"></svg-icon
                                                        ></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </my-tab>

                        <my-tab [tabTitle]="'Burning Questions'">
                            <div class="page-section">
                                <div class="page-section-header">
                                    <div class="page-section-buttons">
                                        <a
                                            (click)="
                                                doCreate('burningquestion')
                                            "
                                            (keypress)="
                                                doCreate('burningquestion')
                                            "
                                            class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon">
                                            <svg-icon
                                                icon="plus"
                                                alt="plus"></svg-icon>
                                            <span translate
                                                >Create New Burning
                                                Questions</span
                                            >
                                        </a>
                                    </div>
                                </div>
                                <div class="page-section-content">
                                    <page-loader
                                        *ngIf="!isLoaded"></page-loader>
                                    <div
                                        class="table-responsive"
                                        *ngIf="isLoaded">
                                        <table class="table">
                                            <thead>
                                                <tr>
                                                    <th
                                                        style="width: 30%"
                                                        translate>
                                                        Question
                                                    </th>
                                                    <th style="width: 15%">
                                                        Counselor Name
                                                    </th>
                                                    <th
                                                        *ngIf="
                                                            seriesPageType !=
                                                            'customType'
                                                        "
                                                        style="width: 15%">
                                                        Category
                                                    </th>
                                                    <th style="width: 5%"></th>
                                                    <th style="width: 5%"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngIf="
                                                        burningQuestionList.length ===
                                                        0
                                                    ">
                                                    <td
                                                        colspan="5"
                                                        class="no-data-message">
                                                        No data found
                                                    </td>
                                                </tr>
                                                <tr
                                                    *ngFor="
                                                        let course of burningQuestionList
                                                    ">
                                                    <td>
                                                        {{ course.titleen }}
                                                    </td>
                                                    <td>
                                                        {{ course.authoren }}
                                                    </td>
                                                    <td
                                                        *ngIf="
                                                            seriesPageType !=
                                                            'customType'
                                                        ">
                                                        {{ course.category }}
                                                    </td>
                                                    <td>
                                                        <a
                                                            tabindex="0"
                                                            class="pull-right"
                                                            (click)="
                                                                voiceRoute(
                                                                    'burningQuestions',
                                                                    course.id
                                                                )
                                                            "
                                                            translate
                                                            >View</a
                                                        >
                                                    </td>
                                                    <td>
                                                        <a
                                                            tabindex="0"
                                                            class="action-icon pull-right"
                                                            (click)="
                                                                onEdit(
                                                                    course.id,
                                                                    'burningquestion'
                                                                )
                                                            "
                                                            (keypress)="
                                                                onEdit(
                                                                    course.id,
                                                                    'burningquestion'
                                                                )
                                                            "
                                                            aria-label="Edit burning question"
                                                            ><svg-icon
                                                                icon="edit"
                                                                class="table-icon"></svg-icon
                                                        ></a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </my-tab>
                    </my-tabs>
                </div>
            </my-tab>

            <my-tab [tabTitle]="'Daily'" *ngIf="seriesPageType != 'customType'">
                <div class="page-section">
                    <div class="page-section-header">
                        <div class="header-row">
                            <div class="drop-down-field">
                                <select
                                    class="app-c-form-control"
                                    [(ngModel)]="selectedGroupId"
                                    (change)="onGroupChange()"
                                    [disabled]="
                                        !dailyGroups || dailyGroups.length === 0
                                    ">
                                    <option
                                        *ngFor="let g of dailyGroups"
                                        [value]="g.ID">
                                        {{ g.Name }}
                                    </option>
                                </select>
                            </div>
                            <div class="page-section-buttons">
                                <a
                                    (click)="doCreate('daily')"
                                    (keypress)="doCreate('daily')"
                                    class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon">
                                    <svg-icon icon="plus" alt="plus"></svg-icon>
                                    <span translate
                                        >Import New Daily Contents</span
                                    >
                                </a>
                            </div>
                            <div
                                class="page-section-buttons"
                                *ngIf="dailyList?.length != 0">
                                <a
                                    (click)="doAdd('daily')"
                                    (keypress)="doAdd('daily')"
                                    class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon">
                                    <svg-icon icon="plus" alt="plus"></svg-icon>
                                    <span translate
                                        >Add to Existing Daily Content</span
                                    >
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="page-section-content">
                        <page-loader *ngIf="!isLoaded"></page-loader>
                        <div class="table-responsive" *ngIf="isLoaded">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 8%" translate>
                                            Serial No
                                        </th>
                                        <th style="width: 8%" translate>
                                            Category ID
                                        </th>
                                        <th style="width: 6%" translate>
                                            Category
                                        </th>
                                        <th style="width: 25%" translate>
                                            Daily Boost-English
                                        </th>
                                        <th style="width: 25%" translate>
                                            Daily Boost-French
                                        </th>
                                        <th style="width: 25%" translate>
                                            Daily Boost-Spanish
                                        </th>
                                        <th style="width: 3%"></th>
                                    </tr>
                                    <tr>
                                        <th></th>
                                        <th></th>
                                        <th>
                                            <input
                                                type="text"
                                                class="app-c-form-control"
                                                [(ngModel)]="cols[0]"
                                                (input)="filterValue(0)" />
                                        </th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngIf="dailyList?.length === 0">
                                        <td colspan="5" class="no-data-message">
                                            No data found
                                        </td>
                                    </tr>
                                    <tr
                                        *ngFor="
                                            let daily of dailyList;
                                            let i = index
                                        ">
                                        <td>{{ i + 1 }}</td>
                                        <td>{{ daily.categoryid }}</td>
                                        <td>{{ daily.categorytitle }}</td>
                                        <td [innerHTML]="daily.quotesen"></td>
                                        <td [innerHTML]="daily.quotesfr"></td>
                                        <td [innerHTML]="daily.quoteses"></td>
                                        <td>
                                            <a
                                                tabindex="0"
                                                class="action-icon pull-right"
                                                (click)="
                                                    onEdit(daily.id, 'daily')
                                                "
                                                (keypress)="
                                                    onEdit(daily.id, 'daily')
                                                "
                                                aria-label="Edit daily"
                                                ><svg-icon
                                                    icon="edit"
                                                    class="table-icon"></svg-icon
                                            ></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </my-tab>

            <my-tab [tabTitle]="'Reads'">
                <div class="page-section">
                    <div class="page-section-header">
                        <div class="page-section-buttons">
                            <a
                                (click)="doCreate('reads')"
                                (keypress)="doCreate('reads')"
                                class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon">
                                <svg-icon icon="plus" alt="plus"></svg-icon>
                                <span translate>Create New Read</span>
                            </a>
                        </div>
                    </div>
                    <div class="page-section-content">
                        <page-loader *ngIf="!isLoaded"></page-loader>
                        <div class="table-responsive" *ngIf="isLoaded">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th style="width: 25%" translate>
                                            Name
                                        </th>
                                        <th style="width: 25%"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngIf="readsList.length === 0">
                                        <td colspan="5" class="no-data-message">
                                            No data found
                                        </td>
                                    </tr>
                                    <tr *ngFor="let course of readsList">
                                        <td>
                                            {{ course.titleen }}
                                            <span *ngIf="course.active === 0"
                                                >(Unpublished)</span
                                            >
                                        </td>
                                        <td>
                                            <a
                                                tabindex="0"
                                                class="action-icon pull-right"
                                                (click)="
                                                    onEdit(course.id, 'reads')
                                                "
                                                (keypress)="
                                                    onEdit(course.id, 'reads')
                                                "
                                                aria-label="Edit reads"
                                                ><svg-icon
                                                    icon="edit"
                                                    class="table-icon"></svg-icon
                                            ></a>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </my-tab>
        </my-tabs>
    </div>
</div>
